export const DEFAULT_FAB_SIZE = 30;
export type VolumeLayout = "slider" | "buttons";
export type Layout = "card" | "slim";
